import React from "react";
// import InvoicesTableSection from "./invoicesTableSection";
import CreditCardInfoSection from "./creditCardInfoSection";
import AchInfoSection from "./achInfoSection";
import ComponentHeader from "../CommonComponents/componentHeader";
import InvoicesTableSection from "./invoicesTableSection";

const PAYMENT_COMPONENT = "PAYMENT_COMPONENT";

const PaymentsWrapper = () => {


    return (
        <>
            <ComponentHeader title="Payments"/>
            <div className="mt-0">
                <div className="p-2">
                    <span className="sub-title">Payment method</span>
                    <CreditCardInfoSection/>
                    <AchInfoSection/>
                </div>
                <div className="p-2">
                    <InvoicesTableSection/>
                </div>
            </div>
            
        </>
    )
}

export default PaymentsWrapper;
export {PAYMENT_COMPONENT};

